export const orderStatus = {
	orderProcessing: 'Order Processing',
	cancelled: 'Cancelled',
	shippedCollected: 'Shipped / Collected',
	cancelPending: 'Cancel Pending',
};
